/**
 * @ngdoc Filter
 * @name validSummaryDataFilter
 */
(function() {
    'use strict';

    angular.module('vrm.components')
        .filter('validSummaryDataFilter', validSummaryDataFilter)
        .filter('notExtendedFilter', notExtendedFilter);

    /**
     * @constructor
     */
    function validSummaryDataFilter() {

        return function(data){
            return _.filter(data, function(item) {
                return item != null && typeof item === 'object' && 'code' in item;
            });
        };
    }

    /**
     * @constructor
     */
    function notExtendedFilter() {
        return function(data, extended){
            return _.filter(data, function(item) {
                return extended.indexOf(item.code) < 0;
            });
        };
    }

})();
